export default "__VITE_ASSET__CZjFViH6__"